import { ActiveBundlePageType, ActiveBundlePageTypeKeys, TimelineChronologyPage } from '@/store';

export const transformPagesToPageNumbers = (
  pages: TimelineChronologyPage[],
  bundlePageType: ActiveBundlePageTypeKeys
): number[] => {
  return pages
    .map((page) =>
      bundlePageType === ActiveBundlePageType.LIGHT ? page.lightBundlePageNumber : page.fullBundlePageNumber
    )
    .filter((pageNumber) => typeof pageNumber === 'number');
};
